import { render, staticRenderFns } from "./CheckboxWithPassword.vue?vue&type=template&id=1050948e&"
import script from "./CheckboxWithPassword.vue?vue&type=script&lang=ts&"
export * from "./CheckboxWithPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports